export function Footer() {
  return (
    <footer className="border-t border-border">
      <div className="container mx-auto container-max px-4 py-6 text-sm text-gray-600">
        <div className="grid md:grid-cols-3 gap-4">
          <div>
            <div className="font-medium">Tips</div>
            <div>Keep posts concise and clear. Aim for 150–300 words.</div>
          </div>
          <div>
            <div className="font-medium">Best Practices</div>
            <div>Use strong openings and clear CTAs. Add relevant hashtags.</div>
          </div>
          <div>
            <div className="font-medium">Credits</div>
            <div>Built with React, Quill, Zustand, and Tailwind.</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
